import BaseCard from './BaseCard';
import { CardType } from './CardType';
import Text from '../../Text';
import GameObject from '../../../GameObject/GameObject';
import Point from '../../../Utility/Point';
import TextComponent from '../../../Component/Render/Text';
import RockCardBehavior from '../../../State/Card/CardBehavior/RockCardBehavior';
import Game from '../../../Game';
import Renderable from '../../../Component/Renderable';
import { addDragonbonesResources } from 'Utility/Resource/ResourceHelper';
import { DRAGONBONES_PATH } from 'Constants/Dragonbones';

export default class RockCard extends BaseCard {
    private pickaxesAmountText: Text;
    private prevPickaxesAmount: number;

    public onCreate(params: any): void {
        params.cardFrontTexture = 'rock';
        params.type = CardType.rock;
        params.dragonbonesName = 'pickaxe03_rock3_exp';
        params.armatureName = 'card_pickaxe_rock';
        params.armatureObjectName = 'rock_armature';

        this.prevPickaxesAmount = RockCardBehavior
            .getPickaxeCardIds(Game.store.getState().levelState.cardsState).length;

        this.pickaxesAmountText = GameObject.Instantiate(Text, {
            x: -18,
            y: -2,
            anchor: new Point(0.5, 0.5),
            text: `${this.prevPickaxesAmount}`,
            style: {
                fontFamily: 'FrancoisOne',
                fontSize: 48,
                fill: '#ffffff',
                stroke: '#522657',
                strokeThickness: 6,
            },
        });
        this.pickaxesAmountText.addComponent(Renderable);

        super.onCreate(params);

        this.addChild(this.pickaxesAmountText);
    }

    public updatePickaxesAmountText(amount: number): void {
        this.prevPickaxesAmount = amount;
        this.pickaxesAmountText.getComponent(TextComponent).text = `${amount}`;
    }

    public updateModifiersVisibility(faceUp: boolean): void {
        this.pickaxesAmountText.getComponent(Renderable).visible = faceUp;
        this.getArmature().getComponent(Renderable).alpha = faceUp ? 1 : 0;
        super.updateModifiersVisibility(faceUp);
    }

    public getPickaxesAmountText(): Text {
        return this.pickaxesAmountText;
    }

    public getPrevPickaxesAmount(): number {
        return this.prevPickaxesAmount;
    }

    public static async preload(): Promise<void> {
        addDragonbonesResources('pickaxe03_rock3_exp', `${DRAGONBONES_PATH}/Pickaxe/`);
    }
}
